import { gql } from "../../../__generated__/gql";

export const UPDATE_BOOKINGS = gql(`
    mutation updateBookings($bandBookings: [BandBookingUpdateInputType]!) {
      updateBandBookings(bandBookings: $bandBookings)
      {
        id
        band  {
          id
          name
        }
        date
        duration
        startTime
        endTime 
        stage {
          name
        }
      }
    }
    `);

export const GET_EDITION_FOR_EDIT = gql(`
        query festivalEditionForEdit($id: String!) {
          festivalEdition(where: {
            id: $id
          }) {
            name
            year
            announcements {
              id
              name
              editionId
              bands {
                id
                      bookingId: id
                      showcase
                      band {
                        id
                        name
                        description
                        imageUrl
                        bookings {
                          id
                          startTime
                          endTime
                        }
                      }
                      date
                      duration
                      stage {
                        id
                        name
                      }
                      startTime
                      endTime
                    }
}

            bands {
              id
              bookingId: id
              showcase
              band {
                id
                name
                description
                imageUrl
                bookings {
                  id
                  startTime
                  endTime
                }
              }
              date
              duration
              stage {
                id
                name
              }
              startTime
              endTime
            }
            days {
              id
              date
              name
            }
          }
        }
        `);
